export const COMPARE_CSV_COLUMNS = [
	"id",
	"name",
	"all_frl",
	"all_prm",
	"all_ela1922",
	"all_ela1924",
	"all_ela2224",
	"all_mth1922",
	"all_mth1924",
	"all_mth2224",
	"all_abs1923",
	"w_frl",
	"w_prm",
	"w_ela1922",
	"w_ela1924",
	"w_ela2224",
	"w_mth1922",
	"w_mth1924",
	"w_mth2224",
	"w_abs1923",
	"b_frl",
	"b_prm",
	"b_ela1922",
	"b_ela1924",
	"b_ela2224",
	"b_mth1922",
	"b_mth1924",
	"b_mth2224",
	"b_abs1923",
	"h_frl",
	"h_prm",
	"h_ela1922",
	"h_ela1924",
	"h_ela2224",
	"h_mth1922",
	"h_mth1924",
	"h_mth2224",
	"h_abs1923",
	"a_frl",
	"a_prm",
	"a_ela1922",
	"a_ela1924",
	"a_ela2224",
	"a_mth1922",
	"a_mth1924",
	"a_mth2224",
	"a_abs1923",
	"m_frl",
	"m_prm",
	"m_ela1922",
	"m_ela1924",
	"m_ela2224",
	"m_mth1922",
	"m_mth1924",
	"m_mth2224",
	"m_abs1923",
	"f_frl",
	"f_prm",
	"f_ela1922",
	"f_ela1924",
	"f_ela2224",
	"f_mth1922",
	"f_mth1924",
	"f_mth2224",
	"f_abs1923",
	"p_frl",
	"p_prm",
	"p_ela1922",
	"p_ela1924",
	"p_ela2224",
	"p_mth1922",
	"p_mth1924",
	"p_mth2224",
	"p_abs1923",
	"np_frl",
	"np_prm",
	"np_ela1922",
	"np_ela1924",
	"np_ela2224",
	"np_mth1922",
	"np_mth1924",
	"np_mth2224",
	"np_abs1923",
  ]
  